export const DESTROY_COLLECTION = `
import AFLNFT from 0xAFLContracts

transaction {
  prepare(acct: auth(LoadValue, UnpublishCapability) &Account) {
    let collection: @AnyResource <- acct.storage.load<@AnyResource>(from: AFLNFT.CollectionStoragePath)
      ?? panic("No collection found")
    destroy collection

    acct.capabilities.unpublish(AFLNFT.CollectionPublicPath)
  }
}
`
